import Vue from 'vue'
import {postBlob} from "@/plugins/axios";

export function getCustomersList(data) {
    return Vue.axios({
        url: '/api/customers/list',
        method: 'get',
        params: {
            ...data
        }
    })
}

/**
 * 客户资料导出
 * @param data
 * @returns {*}
 */
//导出-发票记录
export function exportCustomers(data) {
    return postBlob('/api/customers/export', data)
}

export function searchCustomer(data) {
    return Vue.axios({
        url: '/api/customers/searchCustomer',
        method: 'post',
        data: {...data}
    })
}

// 客户检索：模糊匹配
export function customerSearch(data) {
    return Vue.axios({
        url: '/api/customers/search',
        method: 'post',
        data: {...data}
    })
}

export function getCustomersHideList(data) {
    return Vue.axios({
        url: '/api/customers/hideDataList',
        method: 'get',
        params: {
            ...data
        }
    })
}

// 我的客户资料列表
export function getCustomersSaleList(data) {
    return Vue.axios({
        url: '/api/customerSales/list',
        method: 'get',
        params: {
            ...data
        }
    })
}

/**
 * 客户获取
 * @param data
 * @returns {*}
 */
export function getSellerCustomers(data) {
    return Vue.axios({
        url: '/api/customerSales/index',
        method: 'post',
        data: {
            ...data
        }
    })
}

//export
/**
 * 销售客户资料导出
 * @param data
 * @returns {*}
 */
//导出-发票记录
export function exportSellerCustomers(data) {
    return postBlob('/api/customerSales/export', data)
}


export function getCustomerOptionForPy(data) {
    return Vue.axios({
        url: '/api/customers/optionForPy',
        method: 'get',
        params: {
            ...data
        }
    })
}

export function getCustomersInfoList(data) {
    return Vue.axios({
        url: '/api/customers/customer_list',
        method: 'get',
        params: {
            ...data
        }
    })
}

export function getCustomerOption(data) {
    return Vue.axios({
        url: '/api/customers/customerOption',
        method: 'get',
        params: {
            ...data
        }
    })
}

export function getCustomerSearchOption(data) {
    return Vue.axios({
        url: '/api/customers/searchOption',
        method: 'get',
        params: {
            ...data
        }
    })
}

export function getCustomersDetail(data) {
    return Vue.axios({
        url: '/api/customers/detail',
        method: 'get',
        params: {...data}
    })
}

export function getCustomerSaleDetail(data) {
    return Vue.axios({
        url: '/api/customerSales/detail',
        method: 'get',
        params: {...data}
    })
}

export function getByCustomerSaleId(data) {
    return Vue.axios({
        url: '/api/customerSales/getByCustomerSaleId',
        method: 'post',
        data: {...data}
    })
}

export function addBrand(data) {
    return Vue.axios({
        url: '/api/customers/updateBrand',
        method: 'post',
        data: {...data}
    })
}

export function addOrEditCustom(data) {
    return Vue.axios({
        url: '/api/customers/store',
        method: 'post',
        data: {...data}
    })
}

// 我的客户 销售的客户保存
export function addOrEditSaleCustom(data) {
    return Vue.axios({
        url: '/api/customerSales/store',
        method: 'post',
        data: {...data}
    })
}
// 我的客户的历史开票记录
export function getSaleCustomHistoryTitleList(data) {
    return Vue.axios({
        url: '/api/customerSales/title_list',
        method: 'post',
        data: {...data}
    })
}
export function deleteCustom(data) {
    return Vue.axios({
        url: '/api/customers/destroy',
        method: 'get',
        params: {...data}
    })
}

export function deleteSaleCustom(data) {
    return Vue.axios({
        url: '/api/customerSales/destroy',
        method: 'post',
        data: {...data}
    })
}

export function deleteSaleCustomContract(data) {
    return Vue.axios({
        url: '/api/customerSales/destroyContact',
        method: 'post',
        data: {...data}
    })
}

export function addRecord(data) {
    return Vue.axios({
        url: '/api/records/store',
        method: 'post',
        data: {...data}
    })
}

export function recordList(data) {
    return Vue.axios({
        url: '/api/records/list',
        method: 'get',
        params: {...data}
    })
}

export function getSaleOption(name) {
    return Vue.axios({
        url: '/api/users/userRole',
        method: 'get',
        params: {name}
    })
}

export function isExit(data) {
    return Vue.axios({
        url: '/api/customers/exists',
        method: 'post',
        data: {...data}
    })
}

export function isExitCustomerSales(data) {
    return Vue.axios({
        url: '/api/customerSales/exists',
        method: 'post',
        data: {...data}
    })
}

export function checkOkCustomerSales(data) {
    return Vue.axios({
        url: '/api/customerSales/check_ok',
        method: 'post',
        data: {...data}
    })
}

export function getCustomerContacts(data) {
    return Vue.axios({
        url: '/api/customers/contacts',
        method: 'get',
        params: {
            ...data
        }
    })
}

// 获取销售人员列表
export function getCustomerSaleOption(data) {
    return Vue.axios({
        url: '/api/customers/sales',
        method: 'get',
        params: {...data,}
    })
}

// 获取客户详情
export function pageForCustomerSale(data) {
    return Vue.axios({
        url: '/api/customers/pageForCustomerSale',
        method: 'get',
        params: {...data,}
    })
}

// 合并客户
export function postMergeCustomer(data) {
    return Vue.axios({
        url: '/api/customers/mergeCustomer',
        method: 'post',
        data: {...data}
    })
}

export function postUndoHandel(data) {
    return Vue.axios({
        url: '/api/customers/undoHandel',
        method: 'post',
        data: {...data}
    })
}

/**
 * 客户信用
 * @param data
 * @returns {*}
 */
export function storeCredit(data) {
    return Vue.axios({
        url: '/api/customers/storeCredit',
        method: 'post',
        data
    })
}

/**
 * 客户集团
 * @param data
 * @returns {*}
 */
export function storeCombine(data) {
    return Vue.axios({
        url: '/api/customers/storeCombine',
        method: 'post',
        data
    })
}

/**
 * 我的客户下拉
 * @param params
 * @returns {*}
 */
export function optionsSaleCustomers(params) {
    return Vue.axios({
        url: '/api/customerSales/optionsSaleCustomers',
        method: 'get',
        params
    })
}

/**
 * 指定客户下不同销售的年框
 * @param params
 * @returns {*}
 */
export function theCustomerSalesYF(params) {
    return Vue.axios({
        url: '/api/customerSales/yearFrames',
        method: 'get',
        params
    })
}

/**
 * 修改指定客户下不同销售的年框
 * @param params
 * @returns {*}
 */
export function theCustomerSalesModifyYF(params) {
    return Vue.axios({
        url: '/api/customerSales/modifyYearFrames',
        method: 'get',
        params
    })
}

export function getCustomerExecCorpList(data) {
    return Vue.axios({
        url: '/api/customers/execCorpList',
        method: 'get',
        params: {
            ...data
        }
    })
}

/**
 * 保存执行公司
 * @param data
 * @returns {*}
 */
export function storeExecCorp(data) {
    return Vue.axios({
        url: '/api/customers/storeExecCorp',
        method: 'post',
        data
    })
}


export function deleteExecCorp(data) {
    return Vue.axios({
        url: '/api/customers/deleteExecCorp',
        method: 'get',
        params: {
            ...data
        }
    })
}

export function execCorpSearchOption(customer_id) {
    return Vue.axios({
        url: '/api/customers/execCorpSearchOption',
        method: 'get',
        params: {
            customer_id: customer_id
        }
    })
}

/**
 * 我的客户下拉
 * @param params
 * @returns {*}
 */
export function optionsCustomerSales(params) {
    return Vue.axios({
        url: '/api/customerSales/optionsCustomerSales',
        method: 'get',
        params
    })
}